import React from 'react'
import { FiPhone, FiMail, FiMapPin } from 'react-icons/fi';

const Contacts = () => {
  return (
    <section className="py-4 px-4 bg-gray-900 mt-[1rem] w-full">

      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Phone */}
        <div className="flex items-start space-x-4">
          <div className="p-4 bg-green-100 rounded-full text-green-600">
            <FiPhone size={24} />
          </div>
          <div>
            <h4 className="text-lg font-semibold text-gray-200">Phone</h4>
            <p className="mt-1 text-gray-300">+225 0564021616</p>
            <p className="text-gray-300">+225 2522008055</p>
          </div>

        </div>

        {/* Email */}
        <div className="flex items-start space-x-4">
          <div className="p-4 bg-green-100 rounded-full text-green-600">
            <FiMail size={24} />
          </div>
          <div>
            <h4 className="text-lg font-semibold text-gray-200">Email</h4>
            <p className="mt-1 text-gray-300">infos@godleadershop.ci</p>
            {/* <p className="text-gray-300">support@gmail.com</p> */}
          </div>
        </div>

        {/* Address */}
        <div className="flex items-start space-x-4">
          <div className="p-4 bg-green-100 rounded-full text-green-600">
            <FiMapPin size={24} />
          </div>
          <div>
            <h4 className="text-lg font-semibold text-gray-200">Adresses</h4>
            <p className="mt-1 text-gray-300">Abobo Samanké</p>
            <p className="text-gray-300">Non loin de la pharmacie kennedy</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contacts
